import React, { memo } from "react";
import logo from "@/static/noBgBlack.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { useSnapshot } from "valtio";
import { message } from "antd";
import FeatureCard from "@/pages/Charge/FeatureCard";
import PriceCard from "@/pages/Charge/PriceCard";
import FunctionCard from "@/pages/Charge/FunctionCard";
import { supabaseAuthStore } from "@/utils/store/supabaseAuth";
import {
    AlignRightOutlined,
    CheckCircleFilled,
    EllipsisOutlined,
    ExportOutlined,
    SnippetsOutlined
} from "@ant-design/icons";



interface Props {
}

const Index: React.FC<Props> = memo(() => {
  // 只使用 Supabase 认证状态
  const supabaseAuth = useSnapshot(supabaseAuthStore);
  return (
    <div>
        <div style={{ maxWidth: "90vw" }} className="text-black max-h-[90vh]  overflow-y-auto">
            <div className="flex flex-col">
                <span className="grid grid-cols-5 gap-5 pl-10 pr-10 pt-5">
                    <FeatureCard title={"会议记录快人一步"} desc={"支持会议纪要初稿、录音转文字同步上传，一键生成结构化内容"}/>
                    <FeatureCard title={"调研讨论有据可查"} desc={"自动提炼关键信息点，快速整理讨论内容，形成备忘和输出初稿"}/>
                    <FeatureCard title={"研判决策更聚焦"} desc={"支持提取核心观点与事实依据，协助推进立项、投研、尽调、业务分析等流程"}/>
                    <FeatureCard title={"跟进事项不再遗漏"} desc={"自动识别行动项与责任人，生成跟进记录，适配投后、客户管理、项目进展"}/>
                    <FeatureCard title={"总结汇报一键导出"} desc={"支持一键生成纪要 Word，供复盘、汇报、对外沟通使用"}/>
                </span>
                <div className="flex pl-10 pr-10 justify-center p-10 pb-5">
                    <div className="w-100">
                        <PriceCard title={"11"} desc={"22"}/>
                    </div>
                </div>
                <div className="grid grid-cols-4 gap-5  justify-center w-[80vw] self-center">
                    <FunctionCard icon={<SnippetsOutlined style={{color: "#9CA3AF" ,fontSize: "32px"}}/>} title={"录音转文字"} desc={"准确率98%"}/>
                    <FunctionCard icon={<AlignRightOutlined style={{color: "#9CA3AF" ,fontSize: "32px"}}/>} title={"AI整理内容"} desc={"摘要、问答、关键词"}/>
                    <FunctionCard icon={<ExportOutlined style={{color: "#9CA3AF" ,fontSize: "32px"}}/>} title={"文稿编辑与导出"} desc={"支持Word/TXT"}/>
                    <FunctionCard icon={<EllipsisOutlined style={{color: "#9CA3AF" ,fontSize: "32px"}}/>} title={"更多功能预告"} desc={"悬浮字幕、灵感记录等"}/>
                </div>
                {/*<div className="grid grid-cols-2 gap-5  justify-center w-[50vw] self-center">*/}

                {/*</div>*/}
            </div>
        </div>
    </div>
  );
});
Index.displayName = "Index";

export default Index;